import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import { useTheme } from '@forma/forma-ui-theme';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';

import mockApi from '@/api/mockApi';

import styles from '../StaticPage.module.css';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const mainData = await mockApi.getMainData(params.locale);
  const pageData = await mockApi.getHTMLPageData(params.locale, `license/${params.date}`);
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData,
      },
      license: pageData,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const ContentPage = ({ license }) => {
  const { t } = useTranslation();

  const metaData = {
    title: t('meta_titles.license'),
    description: t('meta_descriptions.license'),
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  return (
    <div className="container">
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      {license &&
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: license }} />
      }
    </div>
  );
};

export default ContentPage;
